import { BusinessAnalyticsLayout } from "../layouts/BusinessAnalyticsLayout";
import { BusinessAnalyticsInstance } from "../utils/businessAnalyticsClass";
import { Dashboard } from "./DashboardPage";

export const CheckInsAnalyticsPage = () => {
  const initializeBusinessAnalytics = async () => {
    await BusinessAnalyticsInstance.initialize();
  };

  return (
    <Dashboard header="Check-in Analytics">
      <BusinessAnalyticsLayout actions={{ get: initializeBusinessAnalytics }}></BusinessAnalyticsLayout>
    </Dashboard>
  );
};
